(() => {
  const API_KEY = '__biceekProductLayout';
  if (window[API_KEY]) {
    window[API_KEY].initialise();
    return;
  }

  const mainSelector = '[data-bf-product-main]';
  const slotSelector = '[data-bf-product-ugc-slot]';
  const ownerSelector = '.bf-product-ugc-section';
  const sectionSelector = '[data-bf-product-ugc]';
  const anchorSelector = '[data-bf-product-ugc-anchor]';

  const restoreUGC = () => {
    const section = document.querySelector(`${slotSelector} > ${sectionSelector}`);
    const anchor = document.querySelector(anchorSelector);
    if (section && anchor?.isConnected) anchor.after(section);
  };

  const mountUGC = () => {
    const main = document.querySelector(mainSelector);
    const slot = main?.querySelector(slotSelector);
    const section = document.querySelector(sectionSelector);
    if (!slot || !section || slot.contains(section)) return;

    let anchor = document.querySelector(anchorSelector);
    if (!anchor) {
      anchor = document.createElement('span');
      anchor.hidden = true;
      anchor.dataset.bfProductUgcAnchor = '';
      section.before(anchor);
    }

    // Keep Shopify's section wrapper at the template root. Nesting that wrapper
    // inside another section makes the theme editor report broken HTML.
    slot.append(section);
  };

  let frame = 0;
  const initialise = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      mountUGC();
    });
  };

  window[API_KEY] = { initialise };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:reorder', initialise);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target?.matches?.(ownerSelector)) {
      const mounted = document.querySelector(`${slotSelector} > ${sectionSelector}`);
      if (mounted) event.target.append(mounted);
      return;
    }
    if (!event.target?.querySelector?.(mainSelector)) return;
    window.cancelAnimationFrame(frame);
    frame = 0;
    restoreUGC();
  });
})();
